var map = {
	"./claim.js": 5029,
	"./node.js": 20405,
	"./private.js": 84422,
	"./purchase.js": 33582,
	"./server.js": 57762,
	"./stake.js": 75659,
	"./stakeRecord.js": 92322,
	"./wallet.js": 68828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46453;